import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { LinkPiecesComponent } from '../link-pieces/link-pieces.component';
import { ConfigService } from 'src/app/shared/services/config.service';
@Component({
  selector: 'app-pallet-details',
  templateUrl: './pallet-details.component.html',
  styleUrls: ['./pallet-details.component.scss'],
})
export class PalletDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild('boxinput', { static: false }) inputEl: ElementRef;
  piecesList: any;
  selectedCars: [];
  ctrycode;
  ctryServiceCode;
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  selections = new SelectionModel<any>(true, []);
  displayedColumns: string[] = [
    'select1',
    'shipmentID1',
    'shipperReference1',
    'PieceID1',
    'shipmentDeclaredValueCurrency1',
    'ctryCode1',
    'serviceCode1',
  ];
  @ViewChild('linkedPaginator') linkedPaginator: MatPaginator;
  @ViewChild('linkedMatSort') linkedMatSort: MatSort;
  selectedMAWB: any;
  selectedPalletID: any;
  selectedShipmentsDlink: any;
  selectedShipmentsLink: any;
  linkedShipments = [];
  unLinkedShipments = [];
  box_id_forPrint;
  box_id_forPrintLinked;
  dataSources = new MatTableDataSource<any>();
  shipmentID;
  isPalletClosed = false;

  UnlinkedpiecesList1: any;
  selected1: [];
  dataSource1 = new MatTableDataSource<any>();
  selection1 = new SelectionModel<any>(true, []);
  selections1 = new SelectionModel<any>(true, []);
  displayedColumns1: string[] = [
    'select',
    'shipmentID',
    'shipperReference',
    'pieceID',
    'shipmentDeclaredValueCurrency',
    'destination_country',
    'dest_srva_code',
  ];
  @ViewChild('unlinkedPaginator') unlinkedPaginator: MatPaginator;
  @ViewChild('unlinkedMatSort') unlinkedMatSort: MatSort;
  selectedShipmentsDlink1: any;
  selectedShipmentsLink1: any;
  linkedShipments1 = [];
  unLinkedShipments1 = [];
  motherStatus: string;
  pieceLevelLabelPrint: boolean;
  mawbInvoiceReference: string = '';
  mawbInvoiceNumber: string = '';

  ////////////////////////////////

  // loose bbx
  lbbxSelected: [];
  lbbxDataSource = new MatTableDataSource<any>();
  lbbxSelection = new SelectionModel<any>(true, []);
  // lbbxSelections = new SelectionModel<any>(true, []);
  lbbxDisplayedColumns: string[] = [
    'lbbxSelect',
    'lbbxShipmentID',
    'lbbxCustomerRef',
    'lbbxShipmentDeclCurrency',
    'lbbxReceiver',
    'lbbxDestination',
    'lbbxStatus',
  ];
  @ViewChild('lbbxLinkedPaginator') lbbxLinkedPaginator: MatPaginator;
  @ViewChild('lbbxLinkedMatSort') lbbxLinkedMatSort: MatSort;

  looseBbx: boolean = false;
  bbxWorkflow: any;
  tabLabel: string;
  lbbxLinkedShipmentList = [];
  selectedShipmentsDelinkLbbx: any;
  linkedPiecesCurrencies = [];
  hasChargesConfig: boolean = false;
  additionalCharges = [];
  invoiceReference = [];

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private shipmentService: ShipmentService,
    private mawService: MawbService,
    private errorDialogService: ErrorDialogService,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mawbId: string;
      palletId: string;
      palletStatus: string;
      countryCode: string;
      countryServiceCode: string;
      motherStatus: string;
      looseBbx: boolean;
      additionalCharges: any;
      invoiceReference: any;
      mawbInvoiceReference: string;
      mawbInvoiceNumber: string;
    },
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    this.selectedMAWB = this.data?.mawbId;
    this.selectedPalletID = this.data?.palletId;
    this.isPalletClosed = String(this.data?.palletStatus) === 'true';
    this.ctrycode = this.data?.countryCode;
    this.ctryServiceCode = this.data?.countryServiceCode;
    this.motherStatus = this.data?.motherStatus;
    this.additionalCharges = this.data?.additionalCharges;
    this.invoiceReference = this.data?.invoiceReference;
    this.looseBbx = this.data.looseBbx;
    this.mawbInvoiceReference = this.data?.mawbInvoiceReference;
    this.mawbInvoiceNumber = this.data?.mawbInvoiceNumber;
    if (!this.looseBbx) {
      this.getUnlinkedPieces();
      this.getPiecesList();
    } else {
      this.getLbbxLinkedShipmentsList(this.selectedMAWB);
    }
    this.getPiecesConfig();
    this.loadChargeConfig();
  }

  onMotherReference(e) {
    let payload = {
      mawbInvoiceReference: this.mawbInvoiceReference || '',
      mawbInvoiceNumber: this.mawbInvoiceNumber || '',
    };
    this.mawService.updatemawbreference(this.selectedMAWB, payload).subscribe(() => {});
  }

  loadChargeConfig() {
    this.configService.fetchConfig('additional_charges').then(res => {
      if (res.data) {
        this.hasChargesConfig = (res.data || []).length > 0;
      }
    });
  }

  ngAfterViewInit(): void {
    this.inputEl.nativeElement.focus();
  }

  delinkPiece() {
    if (this.isPalletClosed) {
      return this.errorDialogService.openDialog('alert.palletClosed', false);
    }
    if (this.selection.selected.length == 0) {
      return this.errorDialogService.openDialog(
        'Please select pieces to unlink from Pallet',
        false
      );
    }
    const dailogData = {
      message: 'alert.delinkPieceConfig',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        this.unlinkShipmentPieces();
      }
    });
  }

  isAllSelected() {
    return this.getPageData('link').every(row => this.selection.isSelected(row));
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    this.isAllSelected()
      ? this.selection.deselect(...this.getPageData('link'))
      : this.selection.select(...this.getPageData('link'));

    this.updateSelection('link');
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.shipmentID + 1}`;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSources.filter = filterValue.trim().toLowerCase();
  }

  getPiecesList(filter: any = null) {
    // this.linkedPiecesCurrencies = [];
    this.shipmentService.getPieceList(this.selectedPalletID, filter).subscribe({
      next: (data: any) => {
        if (data != null) {
          this.piecesList = data;
          this.dataSource.data = this.piecesList;
          this.dataSource.sort = this.linkedMatSort;
          this.dataSource.paginator = this.linkedPaginator;
          let arr = [];
          arr = data;
          this.linkedPiecesCurrencies = data.map(obj => obj.shipmentDeclaredValueCurrency);
        }
      },
      // error: error => {
      //   console.error('There was an error!', error);
      // },
    });
  }

  linkShipments() {
    if (this.isPalletClosed) {
      return this.errorDialogService.openDialog('alert.palletClosed', false);
    }

    const data = {
      palletID: this.selectedPalletID,
      pieces: [this.box_id_forPrint],
      mawb: this.selectedMAWB,
    };

    this.mawService.linkPieces(data).subscribe((res: any) => {
      if (res.Errors.length > 0) {
        return this.errorDialogService.openDialog(res.Errors);
      }
      this.selection1.clear();
      this.box_id_forPrint = '';
      this.inputEl.nativeElement.focus();
      this.getPiecesList();
      this.getUnlinkedPieces();
    });
  }

  disableDelink() {
    const selectionLength = this.selection.selected.length;
    if (selectionLength > 0) {
      return true;
    } else {
      return false;
    }
  }

  unlinkShipmentPieces() {
    if (this.selection.selected.length == 0) {
      return this.errorDialogService.openDialog(
        'Please select pieces to unlink from Pallet',
        false
      );
    }
    const unLinkPieces = [];
    const unlinkShipments = [];
    unLinkPieces.push(...this.selection.selected.map(shipment => shipment.pieceID));
    unlinkShipments.push(...new Set(this.selection.selected.map(shipment => shipment.shipmentID)));
    const unique = arr => [...new Set(arr)];

    const data = {
      palletID: this.selectedPalletID,
      pieces: unLinkPieces,
      shipments: unique(unlinkShipments),
      mawb: this.selectedMAWB,
    };
    this.mawService.unlinkPieces(data).subscribe(() => {
      this.selection1.clear();
      this.selection.clear();
      this.getPiecesList();
      this.getUnlinkedPieces();
    });
  }

  onBoxID() {
    this.shipmentID = '';
    this.box_id_forPrint = this.box_id_forPrint.trim();
    if (this.box_id_forPrint.length < 15) {
      this.shipmentID = this.box_id_forPrint;
      this.onShipmentID();
    } else {
      this.linkShipments();
    }
  }

  onBoxIDLinked() {
    this.getPiecesList(this.box_id_forPrintLinked.trim());
  }

  onShipmentID() {
    const Id = this.shipmentID;
    if (this.isPalletClosed) {
      return this.errorDialogService.openDialog('alert.palletClosed', false);
    }
    const shipmentId = Id.trim();
    this.shipmentService.getPieceListWithShipmentId(shipmentId).subscribe({
      next: (data: any) => {
        if (data.length < 1) {
          this.errorDialogService.openDialog('alert.shipmentPieceNotFound', false);
          return;
        }
        const unlinkedPieces = data.filter(pieceData => pieceData.palletID == null);
        if (unlinkedPieces.length < 1) {
          this.errorDialogService.openDialog('alert.shipmentPiecesLinked', false);
          return;
        }
        this.openUnlinkedPieceDailog(unlinkedPieces, Id);
      },
      // error: error => {
      //   console.error('There was an error!', error);
      // },
    });
  }

  openUnlinkedPieceDailog(pieceData, id) {
    const alertDialog = this.dialog.open(LinkPiecesComponent, {
      data: {
        pieces: pieceData,
        palletId: this.selectedPalletID,
        shipmentId: id,
        mawId: this.selectedMAWB,
        pieceLevelLabelPrint: this.pieceLevelLabelPrint,
      },
    });
    alertDialog.afterClosed().subscribe(() => {
      this.getPiecesList();
      this.getUnlinkedPieces();
      this.shipmentID = '';
    });
  }

  //////Unlink/////
  isAllSelected1() {
    return this.getPageData('delink').every(row => this.selection1.isSelected(row));
  }

  getPageData(type: string) {
    if (type === 'delink')
      return this.dataSource1._pageData(this.dataSource1._orderData(this.dataSource1.data));
    else if (type === 'link')
      return this.dataSource._pageData(this.dataSource._orderData(this.dataSource.data));
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows1() {
    this.isAllSelected1()
      ? this.selection1.deselect(...this.getPageData('delink'))
      : this.selection1.select(...this.getPageData('delink'));

    this.updateSelection('delink');
  }

  updateSelection(type: string) {
    if (type === 'delink') {
      this.selectedShipmentsDlink = this.selection1.selected.map(item => item.shipmentID);
    }
    if (type === 'link') {
      this.selectedShipmentsLink = this.selection.selected.map(item => item.shipmentID);
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel1(row?: any): string {
    if (!row) {
      return `${this.isAllSelected1() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection1.isSelected(row) ? 'deselect' : 'select'} row ${row.shipmentID + 1}`;
  }

  linkShipments1() {
    if (this.isPalletClosed) {
      return this.errorDialogService.openDialog('alert.palletClosed', false);
    }
    let linkShipmentCurrencies = [];
    linkShipmentCurrencies = [
      ...this.selection1.selected.map(shipment => shipment.shipmentDeclaredValueCurrency),
    ];
    const firstCurrency = linkShipmentCurrencies[0];

    let allCurrenciesSame: boolean;
    allCurrenciesSame = linkShipmentCurrencies.every(
      shipmentDeclValCurr => shipmentDeclValCurr === firstCurrency
    );
    if (!allCurrenciesSame) {
      return this.errorDialogService.openDialog('alert.selectShipmentSameCurrency', false);
    } else if (
      this.linkedPiecesCurrencies.length > 0 &&
      firstCurrency !== this.linkedPiecesCurrencies[0]
    ) {
      return this.errorDialogService.openDialog('alert.selectShipmentSameCurrencyLink', false);
    }

    const linkPieces = [];
    const linkShipments = [];
    if (this.selection1.selected.length == 0) {
      return this.errorDialogService.openDialog('alert.selectPieceToLinkPallet', false);
    }
    linkPieces.push(...this.selection1.selected.map(shipment => shipment.pieceID));
    linkShipments.push(...this.selection1.selected.map(shipment => shipment.shipmentID));
    const unique = arr => [...new Set(arr)];

    const data = {
      palletID: this.selectedPalletID,
      pieces: linkPieces,
      shipments: unique(linkShipments),
      mawb: this.selectedMAWB,
    };

    this.mawService.linkPieces(data).subscribe((res: any) => {
      if (res.Errors.length > 0) {
        return this.errorDialogService.openDialog(res.Errors, false);
      }
      this.selection1.clear();
      this.selection.clear();
      this.box_id_forPrint = '';
      this.getUnlinkedPieces();
      this.getPiecesList();
    });
  }

  dateAppend(date: string) {
    if (date.length < 2) {
      return '0' + date;
    }
  }

  getUnlinkedPieces() {
    const lastThirtyDays = new Date();
    lastThirtyDays.setDate(lastThirtyDays.getDate() - 30);

    const d = new Date();
    let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    let fromMonth = (lastThirtyDays.getMonth() + 1).toString();
    let fromDate = lastThirtyDays.getDate().toString();
    if (fromMonth.toString().length < 2) {
      fromMonth = this.dateAppend(fromMonth.toString());
    }
    if (fromDate.toString().length < 2) {
      fromDate = this.dateAppend(fromDate.toString());
    }
    const fromFullDate = `${lastThirtyDays.getFullYear()}${fromMonth}${fromDate}`;
    const date = year + month + day;
    const data = {
      mawb: this.selectedMAWB,
      daterange: {
        datefield: 'upload_datetime',
        fromdate: fromFullDate,
        todate: date,
      },
    };
    this.shipmentService.getPieceListWithMawbId(data).subscribe({
      next: (data: any) => {
        const unlinkedPieces = data.filter(pieceData => pieceData.palletID == null);
        this.dataSource1.data = unlinkedPieces;
        this.dataSource1.sort = this.unlinkedMatSort;
        this.dataSource1.paginator = this.unlinkedPaginator;
      },
      // error: error => {
      //   console.error('There was an error!', error);
      // },
    });
  }
  getWorkflowConfig() {
    this.configService.fetchConfig('loose_bbx').then(response => {
      this.bbxWorkflow = response.data[0];
      this.looseBbx = this.bbxWorkflow === 'Yes' ? true : false;
      if (this.looseBbx == false) {
        this.selectedPalletID = this.data?.palletId;
        this.isPalletClosed = String(this.data?.palletStatus) === 'true';
        this.getUnlinkedPieces();
        this.getPiecesList();
      } else {
        this.getLbbxLinkedShipmentsList(this.selectedMAWB);
      }
    });
  }

  getLbbxLinkedShipmentsList(mawbId) {
    const data = {
      mawbId: mawbId,
    };
    this.shipmentService.getLbbxLinkedShipments(data).subscribe(response => {
      this.lbbxLinkedShipmentList = response['message'];
      this.lbbxDataSource.data = this.lbbxLinkedShipmentList;
      this.lbbxDataSource.sort = this.lbbxLinkedMatSort;
      this.lbbxDataSource.paginator = this.lbbxLinkedPaginator;
      console.log(data);
    });
  }

  lbbxDelinkShipment() {
    if (this.lbbxSelection.selected.length == 0) {
      return this.errorDialogService.openDialog('alert.selectShipmentUnlink', false);
    }
    const dailogData = {
      message: 'alert.delinkShipments',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        this.lbbxUnlinkShipment();
      }
    });
  }
  toggleAllRowsLbbx() {
    if (this.isAllSelectedLbbx()) {
      this.lbbxSelection.clear();
      return;
    }

    this.lbbxSelection.select(...this.lbbxDataSource.data);
  }
  isAllSelectedLbbx() {
    this.selectedShipmentsDelinkLbbx = this.lbbxSelection.selected;
    const numSelected = this.lbbxSelection.selected.length;
    const numRows = this.lbbxDataSource.data.length;
    return numSelected === numRows;
  }

  checkboxLabelLbbx(row?: any): string {
    if (!row) {
      return `${this.isAllSelectedLbbx() ? 'deselect' : 'select'} all`;
    }
    return `${this.lbbxSelection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.shipmentID + 1
    }`;
  }

  lbbxUnlinkShipment() {
    if (this.lbbxSelection.selected.length == 0) {
      return this.errorDialogService.openDialog('alert.selectShipmentUnlink', false);
    }
    const unlinkShipments = [];
    unlinkShipments.push(
      ...new Set(this.lbbxSelection.selected.map(shipment => shipment.shipmentID))
    );
    const unique = arr => [...new Set(arr)];

    const data = {
      mawb: '',
      shipmentIds: unique(unlinkShipments),
    };
    this.mawService.lbbxMotherLink(data).subscribe(() => {
      this.selection.clear();
      this.getLbbxLinkedShipmentsList(this.selectedMAWB);
    });
  }
  getPiecesConfig() {
    this.configService.fetchConfig('label_print_config').then(response => {
      this.pieceLevelLabelPrint = response.data[0].printPieceLevel == 'Yes' ? true : false;
    });
  }
}
